<template>
    <div class="total-row">
        <span>{{total | toCurrency}}</span>
    </diV>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      field: {},
      value: '',
    },
    computed: {
        ...mapState('payments', { total: 'total' }),
    }
  };
</script>

<style>
.total-row {
    height: auto;
    width:auto;
    border: 0;
    padding: 0;
}
.total-row span {
    font-weight: 600;
    font-size:20px;
}
</style>
